import type { ReactElement, ReactNode } from "react";
import type { PolicyKey } from "../commons/policies";
import { usePermission } from "./usePermission";

interface CanProps {
    policy: PolicyKey;
    children: ReactNode;
    fallback?: ReactNode;
}

/** Renders the children only if the user holds the permission. */
export const Can = ({
    policy,
    children,
    fallback = null,
}: CanProps): ReactElement => {
    const allowed = usePermission(policy);
    return <>{allowed ? children : fallback}</>;
};
